import { render } from "./OfficeForm.vue?vue&type=template&id=790626b6"
import script from "./OfficeForm.vue?vue&type=script&lang=js"
export * from "./OfficeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__